import React from "react";
import { Navbar } from "../Components/Navbar/Navbar";
import { Slider } from "../Components/Slider/Slider";
import { SliderSmall } from "../Components/SliderSmall/SliderSmall";
import { Footer } from "../Components/Footer/Footer";
import { BannerDriver } from "../Components/BannerDriver/BannerDriver";
import "./Landing.css";

export const Landing = () => {
  return (
    <div className="gridcontainer">
      <Navbar></Navbar>
      <Slider />
      <SliderSmall />
      <BannerDriver />
      <Footer />
    </div>
  );
};
